import { useQuery, useQueryClient } from '@tanstack/react-query'
import { getRolloutStatus } from '@/api/priceRollout'

/** Ein Abruf für Seitenkopf, Reiter „Rollouts“ und die LIVE-Rückfrage der Regeln (gleicher Query-Key). */
export function useRolloutStatus() {
  return useQuery({ queryKey: ['rollout-status'], queryFn: () => getRolloutStatus() })
}

export function useRolloutStatusNeuLaden() {
  const queryClient = useQueryClient()
  return () => queryClient.invalidateQueries({ queryKey: ['rollout-status'] })
}
